/** Match only dashboard creation/copy requests sent to the configured Metabase instance. */
export function isDashboardCreationRequest(url, method, instanceUrl, pageUrl) {
  if (String(method).toUpperCase() !== "POST") return false;
  try {
    const base = new URL(instanceUrl, pageUrl);
    const request = new URL(url, pageUrl);
    const prefix = base.pathname.replace(/\/$/, "");
    if (request.origin !== base.origin) return false;
    const path = request.pathname;
    return path === prefix + "/api/dashboard" ||
      path === prefix + "/api/dashboard/" ||
      new RegExp("^" + prefix.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "/api/dashboard/[0-9]+/copy/?$").test(path);
  } catch {
    return false;
  }
}

export async function registerCreatedDashboard(status, readBody, register, onError) {
  if (status < 200 || status >= 300) return;
  try {
    const dashboard = await readBody();
    if (!Number.isInteger(dashboard?.id) || dashboard.id <= 0) {
      throw new Error("Metabase did not return a valid dashboard id.");
    }
    await register({
      kind: "dashboard",
      metabase_id: dashboard.id,
      title: dashboard.name || "Untitled dashboard",
    });
  } catch (error) {
    onError(error);
  }
}
